import {useState, useEffect} from 'react';

export const useScrollTop = () => {
  const [isDisplay, setIsDisplay] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsDisplay(true);
    } else {
      setIsDisplay(false);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scroll({
      top: 0,
      behavior: 'smooth',
    });
  };

  return {isDisplay, scrollToTop};
};
